import React, { useMemo, useState } from 'react';
import { blogPosts, featuredPost } from '../../blogs/data/blogData';
import ResourcesHeroSection from './ResourcesHeroSection';
import ResourcesFilterBar from './ResourcesFilterBar';
import ResourcesArticleGrid from './ResourcesArticleGrid';
import { postMatchesPill, aeoPosts } from './resourcesData';

const PAGE_SIZE = 9;

const matchesQuery = (post, query) => {
    if (!query.trim()) return true;
    const q = query.trim().toLowerCase();
    return post.title.toLowerCase().includes(q) || (post.excerpt || '').toLowerCase().includes(q);
};

const ResourcesMainSection = () => {
    const [query, setQuery] = useState('');
    const [category, setCategory] = useState('All');
    const [contentType, setContentType] = useState('All');
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

    const matches = (post) => postMatchesPill(post, category) && matchesQuery(post, query);
    const matchesType = (post) => contentType === 'All' || (contentType === 'AEO Articles' ? post.isAeo : !post.isAeo);

    const featuredVisible = (matchesType(featuredPost) && matches(featuredPost)) ? featuredPost : null;
    // AEO articles listed first — their canonical home is /[icp]/[slug], this grid links out to them.
    const otherPosts = useMemo(
        () => [...aeoPosts, ...blogPosts].filter(p => p.slug !== featuredPost.slug && matchesType(p) && matches(p)),
        [category, query, contentType]
    );

    const totalCount = (featuredVisible ? 1 : 0) + otherPosts.length;
    const visiblePosts = otherPosts.slice(0, visibleCount);
    const hasMore = visibleCount < otherPosts.length;

    const handleCategoryChange = (c) => { setCategory(c); setVisibleCount(PAGE_SIZE); };
    const handleQueryChange = (q) => { setQuery(q); setVisibleCount(PAGE_SIZE); };
    const handleTypeChange = (t) => { setContentType(t); setVisibleCount(PAGE_SIZE); };

    return (
        <>
            <ResourcesHeroSection query={query} onQueryChange={handleQueryChange} />
            <ResourcesFilterBar active={category} onChange={handleCategoryChange} typeActive={contentType} onTypeChange={handleTypeChange} />
            <ResourcesArticleGrid
                featured={featuredVisible}
                totalCount={totalCount}
                visiblePosts={visiblePosts}
                hasMore={hasMore}
                onShowMore={() => setVisibleCount(v => v + PAGE_SIZE)}
            />
        </>
    );
};

export default ResourcesMainSection;
